// GI17 출고취소(비제스트) 2.0 — moms-be 호출부. 1.0 공통 그리드(/api/common/gridsub · /api/grid/search ·
// /api/grid/save)와 /api/internal/data/send 는 쓰지 않는다 (LOGISPRD-16035).
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import { BIZEST_CANCEL_RESULT_MENU_CODE } from './consts'
import type { BizestCancelResultRowDto, BizestCancelResultSearchReq } from './types'

const BASE = '/api/v1/bizest-cancel-results'

/**
 * 조회 — IIF_BIZEST_CANCEL ⟕ OIF_BIZEST_CANCEL. 1.0 처럼 페이징 없이 전체를 받는다(기간 필수, 최대 31일).
 * 주문번호 목록을 수백 건 넣는 쓰임이 있어 GET 쿼리 대신 POST 본문으로 보낸다(URL 한도). 1.0 조회도 POST 였다.
 */
export const searchBizestCancelResults = (body: BizestCancelResultSearchReq) =>
  request.post<ApiResponseV2<BizestCancelResultRowDto[]>, BizestCancelResultSearchReq>(
    `${BASE}/search`,
    body,
    menuCodeHeaders(BIZEST_CANCEL_RESULT_MENU_CODE),
  )
